import React, { useState } from 'react'
import { ChevronDown } from 'react-bootstrap-icons'

const PHASE_CLASS = {
  start: {
    section:
      'bg-rb-phase-start-bg ring-1 ring-transparent dark:bg-rb-dark-mode-lighter/50 dark:ring-rb-dark-mode-lighter/60',
    dot: 'bg-rb-phase-start-dot',
  },
  main: {
    section:
      'bg-rb-phase-main-bg ring-1 ring-transparent dark:bg-rb-dark-mode-lighter/50 dark:ring-rb-dark-mode-lighter/60',
    dot: 'bg-rb-phase-main-dot',
  },
  end: {
    section:
      'bg-rb-phase-end-bg ring-1 ring-transparent dark:bg-rb-dark-mode-lighter/50 dark:ring-rb-dark-mode-lighter/60',
    dot: 'bg-rb-phase-end-dot',
  },
}

export default function ProjectAssetPhaseGroup({
  phaseId,
  label,
  count,
  defaultExpanded = false,
  children,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded)
  const { section, dot } = PHASE_CLASS[phaseId] ?? PHASE_CLASS.main
  const panelClass = expanded
    ? 'timeline-phase-panel timeline-phase-panel--expanded'
    : 'timeline-phase-panel'

  return (
    <section className={`mb-2 w-full max-w-full min-w-0 rounded-lg px-2 py-2 ${section}`}>
      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="flex w-full items-center gap-2.5 text-left"
        aria-expanded={expanded}
      >
        <span
          className={`inline-block size-1.5 shrink-0 rounded-full ${dot}`}
          aria-hidden
        />
        <span className="min-w-0 flex-1 truncate text-xs font-semibold text-rb-black dark:text-white">
          {label}
        </span>
        <span className="text-xs font-semibold text-rb-black dark:text-gray-400">{count}</span>
        <ChevronDown
          className={`shrink-0 text-rb-black transition-transform duration-300 ease-in-out dark:text-gray-300 text-sm ${
            expanded ? 'rotate-180' : ''
          }`}
          aria-hidden
        />
      </button>

      <div className={`${panelClass} w-full min-w-0`} aria-hidden={!expanded}>
        <div className="timeline-phase-panel-inner">
          <div className="mt-2 w-full min-w-0">{children}</div>
        </div>
      </div>
    </section>
  )
}
